/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useSnackbar } from 'notistack';
import React, { useState, useEffect, useRef } from 'react';
import InputField from 'shared-components/inputs/InputField';
import {
  Grid, Dialog, DialogActions, DialogContent, Button, Tooltip,
} from '@mui/material';
import { useQueryClient, useMutation, useQuery } from 'react-query';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';// useLocation
import { useForm } from 'react-hook-form';
import type { RootState } from 'mainStore';
import { useSelector } from 'react-redux';
import Notifications, { notify } from 'react-notify-toast';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ShortTextIcon from '@mui/icons-material/ShortText';
import SubjectIcon from '@mui/icons-material/Subject';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DrawIcon from '@mui/icons-material/Draw';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import type { IFormValues } from 'formsTypes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HookTextField from 'shared-components/hooks/HookTextField';
import { decrypt } from 'shared-components/hooks/useEncryption';
import PrimayButton from 'shared-components/components/PrimayButton';
import StradaLoader from 'shared-components/components/StradaLoader';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CustomLoader from 'shared-components/components/CustomLoader';
import type {
  IErrorResponse, IDetail,
} from '../types';
import RenderFormContent from './RenderFormContent';

const defaultValues: IDetail = {
  content: [{
    unique_position_key: Date.now().toString(),
    type: 'defaultFields',
    label: '',
    value: '',
  }],
  template_name: '',
};

function FormDropdownIcon(): JSX.Element {
  return (
    <svg width='24' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M15.043 2.45703C14.7383 2.15234 14.3867 2 13.9883 2H3.51172C3.11328 2 2.76172 2.15234 2.45703 2.45703C2.15234 2.76172 2 3.11328 2 3.51172V13.9883C2 14.3867 2.15234 14.7383 2.45703 15.043C2.76172 15.3477 3.11328 15.5 3.51172 15.5H13.9883C14.3867 15.5 14.7383 15.3477 15.043 15.043C15.3477 14.7383 15.5 14.3867 15.5 13.9883V3.51172C15.5 3.11328 15.3477 2.76172 15.043 2.45703ZM3.51172 3.51172H13.9883V13.9883H3.51172V3.51172ZM12.7 7.9375L11.7625 7L8.7 10.0625L5.6375 7L4.7 7.9375L8.7 11.9375L12.7 7.9375Z' fill='#212121' fillOpacity='0.6' />
    </svg>
  );
}
function FormFileUploadIcon(): JSX.Element {
  return (
    <svg width='24' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.01172 10.25L7 7.26172L9.98828 10.25L8.93359 11.3398L7.73828 10.1445V13.2383H6.26172V10.1445L5.06641 11.3047L4.01172 10.25ZM11.5 14.0117V5.75H7.73828V1.98828H2.5V14.0117H11.5ZM8.51172 0.511719L13.0117 5.01172V14.0117C13.0117 14.4102 12.8594 14.7617 12.5547 15.0664C12.25 15.3477 11.8984 15.4883 11.5 15.4883H2.5C2.10156 15.4883 1.75 15.3477 1.44531 15.0664C1.14062 14.7617 0.988281 14.4102 0.988281 14.0117L1.02344 1.98828C1.02344 1.58984 1.16406 1.25 1.44531 0.96875C1.75 0.664062 2.10156 0.511719 2.5 0.511719H8.51172Z' fill='#212121' fillOpacity='0.6' />
    </svg>
  );
}
function FormNumberIcon(): JSX.Element {
  return (
    <svg width='24' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14.0117 0.988281H1.98828C1.58984 0.988281 1.23828 1.14062 0.933594 1.44531C0.652344 1.72656 0.511719 2.07812 0.511719 2.5V11.5C0.511719 11.9219 0.652344 12.2852 0.933594 12.5898C1.23828 12.8711 1.58984 13.0117 1.98828 13.0117H14.0117C14.4102 13.0117 14.75 12.8711 15.0312 12.5898C15.3359 12.2852 15.4883 11.9219 15.4883 11.5V2.5C15.4883 2.07812 15.3359 1.72656 15.0312 1.44531C14.75 1.14062 14.4102 0.988281 14.0117 0.988281ZM4.73047 9.25H3.85156V5.875L3.18359 6.36719L2.76172 5.69922L4.0625 4.75H4.73047V9.25ZM9.125 9.25H6.20703V8.47656C6.60547 8.07812 6.93359 7.75 7.19141 7.49219C7.47266 7.21094 7.67188 7 7.78906 6.85938C8.07031 6.57812 8.21094 6.32031 8.21094 6.08594C8.21094 5.92187 8.15234 5.79297 8.03516 5.69922C7.94141 5.58203 7.80078 5.52344 7.61328 5.52344C7.40234 5.52344 7.23828 5.58203 7.12109 5.69922C7.02734 5.81641 6.95703 5.94531 6.91016 6.08594L6.17188 5.76953C6.17188 5.74609 6.21875 5.64062 6.3125 5.45312C6.40625 5.24219 6.60547 5.05469 6.91016 4.89062C7.16797 4.77344 7.42578 4.72656 7.68359 4.75C7.96484 4.77344 8.19922 4.83203 8.38672 4.92578C8.71484 5.08984 8.90234 5.30078 8.94922 5.55859C9.01953 5.79297 9.05469 5.94531 9.05469 6.01562C9.05469 6.50781 8.83203 6.97656 8.38672 7.42188C8.29297 7.51562 8.15234 7.65625 7.96484 7.84375C7.80078 8.00781 7.58984 8.21875 7.33203 8.47656V8.51172H9.125V9.25ZM13.0625 8.61719C13.0391 8.64062 12.9805 8.71094 12.8867 8.82812C12.793 8.92188 12.6523 9.01562 12.4648 9.10938C12.2773 9.20312 12.0312 9.25 11.7266 9.25C11.7266 9.25 11.6562 9.25 11.5156 9.25C11.3984 9.22656 11.2461 9.19141 11.0586 9.14453C10.8945 9.07422 10.7305 8.96875 10.5664 8.82812C10.4023 8.66406 10.2852 8.42969 10.2148 8.125L10.9883 7.80859C10.9883 7.83203 11 7.90234 11.0234 8.01953C11.0703 8.11328 11.1523 8.20703 11.2695 8.30078C11.3867 8.39453 11.5391 8.44141 11.7266 8.44141C11.8906 8.44141 12.043 8.39453 12.1836 8.30078C12.3242 8.20703 12.3945 8.06641 12.3945 7.87891C12.3945 7.66797 12.3125 7.51562 12.1484 7.42188C12.0078 7.32812 11.832 7.28125 11.6211 7.28125H11.2695V6.54297H11.5859C11.7266 6.54297 11.8672 6.50781 12.0078 6.4375C12.1719 6.36719 12.2539 6.21484 12.2539 5.98047C12.2539 5.83984 12.1953 5.73438 12.0781 5.66406C11.9844 5.57031 11.8555 5.52344 11.6914 5.52344C11.5039 5.52344 11.3633 5.57031 11.2695 5.66406C11.1758 5.75781 11.1055 5.86328 11.0586 5.98047L10.3203 5.66406C10.3438 5.59375 10.4023 5.48828 10.4961 5.34766C10.5898 5.18359 10.7305 5.04297 10.918 4.92578C11.1289 4.80859 11.3867 4.75 11.6914 4.75C12.1133 4.75 12.418 4.83203 12.6055 4.99609C12.793 5.16016 12.8984 5.26563 12.9219 5.3125C13.0391 5.5 13.0977 5.71094 13.0977 5.94531C13.0977 6.15625 13.0391 6.33203 12.9219 6.47266C12.8281 6.66016 12.6992 6.78906 12.5352 6.85938V6.89453C12.7461 6.98828 12.9219 7.11719 13.0625 7.28125C13.2031 7.49219 13.2617 7.72656 13.2383 7.98438C13.2383 8.21875 13.1797 8.42969 13.0625 8.61719Z' fill='#212121' fillOpacity='0.6' />
    </svg>
  );
}
function AIIcon(): JSX.Element {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.0117 6.75C15.4102 6.75 15.7734 6.85547 16.1016 7.06641C16.4531 7.25391 16.7344 7.52344 16.9453 7.875C17.1562 8.20312 17.2617 8.57812 17.2617 9C17.2617 9.42188 17.1562 9.80859 16.9453 10.1602C16.7344 10.4883 16.4531 10.7578 16.1016 10.9688C15.7734 11.1562 15.4102 11.25 15.0117 11.25V14.2383C15.0117 14.6602 14.8594 15.0234 14.5547 15.3281C14.2734 15.6094 13.9219 15.75 13.5 15.75H4.5C4.07812 15.75 3.71484 15.6094 3.41016 15.3281C3.12891 15.0234 2.98828 14.6602 2.98828 14.2383V11.25C2.58984 11.25 2.21484 11.1562 1.86328 10.9688C1.53516 10.7578 1.26562 10.4883 1.05469 10.1602C0.84375 9.80859 0.738281 9.42188 0.738281 9C0.738281 8.57812 0.84375 8.20312 1.05469 7.875C1.26562 7.52344 1.53516 7.25391 1.86328 7.06641C2.21484 6.85547 2.58984 6.75 2.98828 6.75V5.23828C2.98828 4.83984 3.12891 4.5 3.41016 4.21875C3.71484 3.91406 4.07812 3.76172 4.5 3.76172H6.75C6.75 3.33984 6.84375 2.96484 7.03125 2.63672C7.24219 2.28516 7.51172 2.01562 7.83984 1.82812C8.19141 1.61719 8.57812 1.51172 9 1.51172C9.42188 1.51172 9.79688 1.61719 10.125 1.82812C10.4766 2.01562 10.7461 2.28516 10.9336 2.63672C11.1445 2.96484 11.25 3.33984 11.25 3.76172H13.5C13.9219 3.76172 14.2734 3.91406 14.5547 4.21875C14.8594 4.5 15.0117 4.83984 15.0117 5.23828V6.75ZM5.625 8.61328C5.625 8.94141 5.73047 9.21094 5.94141 9.42188C6.17578 9.63281 6.44531 9.73828 6.75 9.73828C7.05469 9.73828 7.3125 9.63281 7.52344 9.42188C7.75781 9.21094 7.875 8.94141 7.875 8.61328C7.875 8.30859 7.75781 8.05078 7.52344 7.83984C7.3125 7.60547 7.05469 7.48828 6.75 7.48828C6.44531 7.48828 6.17578 7.60547 5.94141 7.83984C5.73047 8.05078 5.625 8.30859 5.625 8.61328ZM11.9883 12.7617V11.25H6.01172V12.7617H11.9883ZM11.25 9.73828C11.5547 9.73828 11.8125 9.63281 12.0234 9.42188C12.2578 9.21094 12.375 8.94141 12.375 8.61328C12.375 8.30859 12.2578 8.05078 12.0234 7.83984C11.8125 7.60547 11.5547 7.48828 11.25 7.48828C10.9453 7.48828 10.6758 7.60547 10.4414 7.83984C10.2305 8.05078 10.125 8.30859 10.125 8.61328C10.125 8.94141 10.2305 9.21094 10.4414 9.42188C10.6758 9.63281 10.9453 9.73828 11.25 9.73828Z' fill='#212121' fillOpacity='0.87' />
    </svg>
  );
}

function AddRFPForm(): JSX.Element {
  const { tempId } = useParams();
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const taskId = queryParams.get('taskId');

  const queryClient = useQueryClient();
  const [templateData, setTemplateData] = useState<IDetail>({
    template_name: '',
    content: [{
      unique_position_key: Date.now().toString(),
      type: 'defaultFields',
      label: '',
      value: '',
    }],
  });
  const [addContentID, setAddContentID] = useState('');
  const [openAIModel, setOpenAIModel] = useState(false);
  const [formName, setFormName] = useState<string | undefined>('');
  const [detail, setDetail] = useState('');
  const [showRegenerate, setShowRegenerate] = useState<boolean>(false);
  const [isRegenerate, setIsRegenerate] = useState<boolean>(false);
  const [openProgress, setOpenProgress] = useState<boolean>(false);
  const [connectsocket, setConnectSocket] = useState<boolean>(false);
  const [taskDataId, setTaskDataId] = useState<boolean>(false);
  const [socketOpen, setSocketOpen] = useState<boolean>(false);
  const [closed, setClosed] = useState<boolean>(false);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [retryCount, setRetryCount] = useState<number>(0);
  const [deletedItemsIDs, setDeletedItemsIDs] = useState<string[]>([]);
  const [socketConnection, setSocketConnection] = useState<WebSocket | undefined>(undefined);
  const schema = yup.object().shape({
    template_name: yup.string().required('Name is required'),
  });
  const currentWorkspace = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );
  const {
    control, formState, handleSubmit, setValue, watch,
  } = useForm<IFormValues>({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;

  const handleBack = (): void => {
    navigate('/workspace/settings/rfp-template');
  };

  const { isLoading } = useQuery(['get/rfp-template-data', tempId], async () => axios({
    url: `/api/rfp-template/${decrypt(tempId)}/`,
    method: 'GET',
  }), {
    onSuccess: (res: AxiosResponse<IDetail>) => {
      setTemplateData(res.data);
      if (res.data.template_name !== undefined) {
        setValue('template_name', res.data.template_name);
      }
    },
    enabled: tempId !== 'new',
  });

  const { mutate: saveRFPForm } = useMutation(async (data: IDetail) => axios({
    url: `/api/rfp-template/?workspace=${currentWorkspace.id}`,
    method: 'POST',
    data,
  }), {
    onSuccess: async (): Promise<void> => {
      setBtnDisabled(false);
      // navigate('/workspace/settings/rfp-template');
      navigate('/workspace/settings/rfp-template');
      enqueueSnackbar('Form Added Successfully');
      await queryClient.invalidateQueries('get/rfp-template').then();
    },
    onError: (res: IErrorResponse) => {
      setBtnDisabled(false);
      if (res.data.response.code === 'unique') {
        enqueueSnackbar('Template Name Already Exist');
      }
    },
  });
  const { mutate: generateTemplateWithAI } = useMutation(async () => axios({
    url: 'api/chat-gpt/generate-rfp/',
    method: 'post',
    data: {
      rfp_name: formName,
      // is_retry: isRegenerate,
      task_id: taskDataId,
      description: detail,
    },
  }), {
    onSuccess: (res) => {
      setValue('template_name', formName);
      setTaskDataId(res.data.detail.task_id);
      setConnectSocket(true);
      const operatorSimulationSocket = new WebSocket(`${process.env.REACT_APP_SOCKET_URL}ws/task/${res.data.detail.task_id}/`);
      setSocketConnection(operatorSimulationSocket);
    },
    onError: () => {
      // setOpenAI(false);
      setSocketOpen(false);
      setOpenProgress(false);
      setFormName('');
      setDetail('');
      enqueueSnackbar('Error in generating RFP Template', {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });
  useEffect(() => {
    if (connectsocket && socketConnection !== undefined) {
      socketConnection.onopen = (): void => {
        setRetryCount(0);
      };
      socketConnection.onerror = (): void => {
        if (retryCount >= 50) {
          enqueueSnackbar('Error while generating RFP with AI');
          socketConnection.close();
          setSocketOpen(false);
        }
      };
      socketConnection.onmessage = (taskData): void => {
        const streamedData = JSON.parse(taskData.data);
        if (Object.keys(streamedData?.data?.stream_data).length !== 0) {
          setTemplateData((prevTemplateData) => ({
            ...prevTemplateData,
            content: [
              ...prevTemplateData.content, streamedData?.data?.stream_data,
            ],
          }));
          setAddContentID(Date.now().toString());
        }
        if (streamedData?.data?.is_completed) {
          if (streamedData?.data?.message) {
            enqueueSnackbar(streamedData?.data?.message);
          } else {
            const uniqueKeys = new Set();
            const filteredContent = templateData.content.filter((item) => {
              if (uniqueKeys.has(item.unique_position_key)) {
                return false;
              }
              uniqueKeys.add(item.unique_position_key);
              return true;
            });
            setTemplateData((prevState) => ({
              ...prevState,
              content: filteredContent,
            }));
            // eslint-disable-next-line no-restricted-syntax
            for (const newContentObject of streamedData?.data?.complete_data) {
              const isObjectExists = filteredContent.some((contentObj) => contentObj.unique_position_key === newContentObject.unique_position_key);
              if (!isObjectExists && !deletedItemsIDs.includes(newContentObject.unique_position_key)) {
                setTemplateData((prevTemplateData) => ({
                  ...prevTemplateData,
                  content: [
                    ...prevTemplateData.content,
                    newContentObject,
                  ],
                }));
                setAddContentID(Date.now().toString());
              }
            }
            enqueueSnackbar('Successfully generated RFP with AI');
          }

          setShowRegenerate(true);
          setSocketOpen(false);
          socketConnection.close();
        }
      };
      socketConnection.onclose = (): void => {
        if (!closed) {
          if (retryCount < 50) {
            setRetryCount(retryCount + 1);
            setTimeout(() => {
              const operatorSimulationSocket = new WebSocket(`${process.env.REACT_APP_SOCKET_URL}ws/task/${taskDataId}/`);
              setSocketConnection(operatorSimulationSocket);
            }, 1500);
          } else {
            socketConnection.close();
            setSocketOpen(false);
          }
        } else {
          setSocketOpen(false);
          setClosed(false);
        }
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectsocket, socketConnection, deletedItemsIDs, closed, templateData]);

  const handleSocketClose = (): void => {
    if (socketConnection !== undefined) {
      setClosed(true);
      setShowRegenerate(true);
      setSocketOpen(false);
      socketConnection.send(JSON.stringify({ stop_task: true }));
      socketConnection.close();
    }
  };

  useEffect(() => {
    if (bottomRef.current !== null && addContentID !== '') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [addContentID]);
  useEffect(() => {
    if (typeof watch('template_name') === 'string') {
      setFormName(watch('template_name'));
    } else {
      setFormName('');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch('template_name')]);

  const { mutate: updateRFPForm } = useMutation(async (payload: { id: number; data: IDetail }) => axios({
    url: `/api/rfp-template/${payload.id}/`,
    method: 'PATCH',
    data: payload.data,
  }), {
    onSuccess: async (): Promise<void> => {
      setBtnDisabled(false);
      enqueueSnackbar('RFP Form Updated Successfully');
      navigate('/workspace/settings/rfp-template');
      await queryClient.invalidateQueries('get/rfp-template').then();
    },
    onError: (res: IErrorResponse) => {
      setBtnDisabled(false);
      if (res.data.response.code === 'unique') {
        enqueueSnackbar('Template Name Already Exist');
      }
    },
  });

  const onSubmit = (data: IDetail): void => {
    const info = data;
    info.content = templateData.content;
    let error = false;
    setBtnDisabled(true);
    // eslint-disable-next-line array-callback-return
    templateData.content.map((item): void => {
      if (item.type === 'text' && item.value === '') {
        notify.show('Editor text is Required', 'error', 2000);
        error = true;
      } else if (item.type === 'select' && (item.options === undefined || item.options?.length < 2)) {
        notify.show('Add at least 2 Select Options', 'error', 2000);
        error = true;
      } else if (item.type === 'select' && item.options !== undefined && item.options?.length > 1) {
        const isNonEmptyOption = (option: { label: string }): boolean => option.label.trim() !== '';
        const nonEmptyOptions = item.options.filter(isNonEmptyOption);
        if (nonEmptyOptions.length >= 2) {
          const indexOfEmptyOption = item.options.findIndex((option) => option.label.trim() === '');
          if (indexOfEmptyOption !== -1) {
            item.options.splice(indexOfEmptyOption, 1);
          }
        }
        const nonEmptyOptionsCount = item.options.filter(isNonEmptyOption).length;
        if (nonEmptyOptionsCount === 0) {
          notify.show('Option labels are Required in Select Field', 'error', 2000);
          error = true;
        } else if (nonEmptyOptionsCount === 1) {
          notify.show('Add at least 2 Select Options', 'error', 2000);
          error = true;
        } else {
          // No error, remove empty options
          // eslint-disable-next-line no-param-reassign
          item.options = nonEmptyOptions;
          error = false;
        }
      }
    });
    if (!error) {
      if (tempId !== 'new') {
        updateRFPForm({ id: Number(decrypt(tempId)), data });
      } else {
        saveRFPForm(data);
      }
    } else {
      setBtnDisabled(false);
    }
  };
  function addForm(formType: string): void {
    if (templateData !== undefined) {
      const obj = {
        unique_position_key: Date.now().toString(),
        type: formType,
        label: '',
        value: '',
        is_required: false,
      };
      const newData = { ...templateData };
      newData.content.push(obj);
      setTemplateData(newData);
      setAddContentID(Date.now().toString());
    }
  }
  function addDropdownMulitchoiceForm(formType: string): void {
    if (templateData !== undefined) {
      const obj = {
        unique_position_key: Date.now().toString(),
        type: formType,
        label: '',
        value: '',
        is_required: false,
        options: [
          {
            unique_position_key: `${Date.now().toString()}1`,
            label: '',
          },
          {
            unique_position_key: `${Date.now().toString()}2`,
            label: '',
          },
          {
            unique_position_key: `${Date.now().toString()}3`,
            label: '',
          },
        ],
      };
      const newData = { ...templateData };
      newData.content.push(obj);
      setTemplateData(newData);
      setAddContentID(Date.now().toString());
    }
  }
  function handleAI(): void {
    if (isRegenerate) {
      setTemplateData({
        template_name: '',
        content: [{
          unique_position_key: Date.now().toString(),
          type: 'defaultFields',
          label: '',
          value: '',
        }],
      });
    }
    setAddContentID(Date.now().toString());
    generateTemplateWithAI();
    setSocketOpen(true);
    setOpenAIModel(false);
    setShowRegenerate(false);
  }

  return (
    <div style={{ display: 'flex', width: '100%' }} className='Main-purchase-orders'>
      <StradaLoader open={isLoading} />
      {openProgress ? <div style={{ height: '85vh', width: '100%' }} className='d-flex justify-content-center align-items-center'><CustomLoader /></div>
        : (
          <Grid container className='rfpHeader'>
            <Grid item sm={10}>
              <form onSubmit={handleSubmit(onSubmit)} className='template-body'>
                <div className='d-flex justify-space-between align-items-center mt-3' style={{ width: '70%', margin: 'auto' }}>
                  <div>
                    <div className='d-flex'>
                      <span aria-hidden='true' className='back-btn cursor-pointer' onClick={(): void => { handleSocketClose(); handleBack(); }}>
                        <ArrowBackIcon className='back-icon' />
                      </span>
                      <p className='rfp-title'>
                        {tempId !== 'new' ? 'Edit ' : 'Add '}
                        RFP Form
                      </p>
                    </div>
                  </div>
                  <div className='btn-wrapper d-flex justify-content-end mt-2'>
                    <PrimayButton type='submit' disabled={socketOpen || btnDisabled}>
                      Save Form
                    </PrimayButton>
                  </div>
                </div>
                <div className='mt-3' style={{ width: '70%', margin: 'auto' }}>
                  <HookTextField
                    name='template_name'
                    label='Form Name'
                    control={control}
                    disabled={socketOpen}
                    maxLength={150}
                    errors={errors}
                  />
                  <div className='d-flex justify-space-between align-items-center'>
                    <p className='questions-p'>Form Questions</p>
                    {!showRegenerate && !socketOpen
                      && (
                        <div
                          className='generate-task-wrap'
                          style={{ color: '#212121' }}
                          aria-hidden='true'
                          onClick={(): void => { setOpenAIModel(true); }}
                        >
                          <AIIcon />
                          <p>
                            Generate with AI
                          </p>
                        </div>
                      )}
                    {showRegenerate && !socketOpen
                      && (
                        <div
                          className='generate-task-wrap'
                          style={{ color: '#212121' }}
                          aria-hidden='true'
                          onClick={(): void => { setOpenAIModel(true); setIsRegenerate(true); }}
                        >
                          <AIIcon />
                          <p>
                            Regenerate with AI
                          </p>
                        </div>
                      )}

                  </div>
                  <Dialog
                    open={openAIModel}
                    keepMounted
                  >
                    <DialogContent style={{ width: 500, marginBottom: '20px', padding: '0px' }}>
                      <img src={`${process.env.REACT_APP_ASSESTS_URL}AIImage.webp`} alt='' />
                      <div style={{ padding: '20px' }}>
                        <p className='create-template-title'>Strada AI RFP</p>
                        <div className='create-template-div'>
                          <InputField
                            type='text'
                            label='Name'
                            name='name'
                            value={formName}
                            // disabled={isRegenerate}
                            inputProps={{ maxLength: 150 }}
                            // control={control}
                            onChange={(event): void => { setFormName(event.target.value); }}
                          />
                          <p className='bottom-text'>Specific RFP names work best</p>
                        </div>
                        <div className='create-template-div'>
                          <InputField
                            type='text'
                            name='detail'
                            value={detail}
                            inputProps={{ maxLength: 2000 }}
                            placeholder='Additional instructions. e.g., “Give me a maximum of 10 steps, the last step needs to be approved by the property manager”'
                            rows={4}
                            multiline
                            onChange={(event): void => { setDetail(event.target.value); }}
                          />
                          <p className='bottom-text'>This can help fine tune your RFP.</p>
                        </div>
                      </div>
                    </DialogContent>
                    <DialogActions style={{ paddingRight: '20px' }}>
                      <Button
                        style={{ textTransform: 'inherit' }}
                        onClick={(): void => {
                          setOpenAIModel(false);
                          setDetail('');
                        }}
                        color='primary'
                      >
                        Cancel
                      </Button>
                      {formName === '' || formName === undefined || formName.length > 149 || detail.length > 2000
                        ? (
                          <Tooltip title={<span>{formName === '' || formName === undefined ? 'Enter Template Name' : formName.length > 149 ? 'Template Name is too long' : detail.length > 2000 ? 'Template description is too long' : ''}</span>}>
                            <Button
                              variant='contained'
                              style={{ textTransform: 'inherit', color: '#8D8D8D', background: '#EBEBE4' }}

                            >
                              Generate with AI
                            </Button>
                          </Tooltip>
                        )
                        : (
                          <Button
                            variant='contained'
                            style={{ textTransform: 'inherit', color: 'white', background: '#00CFA1' }}
                            aria-hidden='true'
                            onClick={(): void => { handleAI(); }}
                          >
                            Generate with AI
                          </Button>
                        )}
                    </DialogActions>
                  </Dialog>
                </div>
                <RenderFormContent templateData={templateData} setTemplateData={setTemplateData} deletedItemsIDs={deletedItemsIDs} setDeletedItemsIDs={setDeletedItemsIDs} />
                {socketOpen && (
                  <div className='gpt-bar'>
                    <div className='d-flex justify-content-between p-2 align-center'>
                      <h5 className='questions-p'>
                        Generating
                        <span className='host'>
                          <span className='loading-gpt-res loading-0' />
                          <span className='loading-gpt-res loading-1' />
                          <span className='loading-gpt-res loading-2' />
                        </span>
                      </h5>
                      <div
                        className='generate-task-wrap'
                        style={{ color: '#f44a41', padding: '6px 16px' }}
                        aria-hidden='true'
                        onClick={(): void => { handleSocketClose(); }}
                      >
                        <p style={{ marginLeft: '0px' }}>
                          Stop
                          {' '}

                        </p>
                      </div>
                    </div>

                  </div>
                )}
                <div ref={bottomRef} style={{ height: '1px' }} />
              </form>
            </Grid>
            <Grid item sm={2}>
              <div className='right-grid-wrapper'>
                <div className='content-open-div'>
                  <p>Content</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('text'); }}>
                  <TextFieldsIcon />
                  <p>Text</p>
                </div>
                <div className='content-open-div'>
                  <p>Forms</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('textfield'); }}>
                  <ShortTextIcon />
                  <p>Text Field</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('textarea'); }}>
                  <SubjectIcon />
                  <p>Text Area</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('day'); }}>
                  <DateRangeIcon />
                  <p>Day</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('checkbox'); }}>
                  <CheckBoxIcon />
                  <p>Checkbox</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('currency'); }}>
                  <FormNumberIcon />
                  <p>Currency</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addDropdownMulitchoiceForm('select'); }}>
                  <FormDropdownIcon />
                  <p>Select</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('file'); }}>
                  <FormFileUploadIcon />
                  <p>File</p>
                </div>
                <div className='content-item-div' aria-hidden='true' onClick={(): void => { addForm('signature'); }}>
                  <DrawIcon />
                  <p>Signature</p>
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      <Notifications />
    </div>
  );
}

export default AddRFPForm;
